import { useCallback, useState } from "react";

import { dateFromString } from "Utils/Date";
import { IEditFieldProps } from "../../IEditFieldProps";
import { IUseEditDate } from "./IUseEditDate";

export function useEditDate(props: IEditFieldProps): IUseEditDate {
  const {
    fieldName, isRequired, item, onChange, translator
  } = props;

  const [value, setValue] = useState<Date>(dateFromString(item?.[fieldName]));

  const onSelectDate = useCallback(
    (newDate: Date) => {
      if (newDate == null) {
        return;
      }

      setValue(newDate);
      onChange(fieldName, newDate.toISOString());
    },
    [fieldName, onChange]
  );

  let errorMessage = null;
  if (isRequired && value == null) {
    errorMessage = translator.get(`generic.missingvalue`, `This value is missing or invalid.`);
  }

  return {
    errorMessage,
    onChange: onSelectDate,
    value
  };
}
